import moment from 'moment';

const tripDate = (trips, index) => {
  if (trips[index]) {
    return trips[index].date.value;
  }

  return undefined;
};

const lastTripDate = (trips, currentIndex) => {
  const index = currentIndex - 1;

  return tripDate(trips, index);
};

// This functions handles the case where we can not add a date before pervious trip.
const getMinDate = (trips, currentIndex) => {
  if (currentIndex === 0) {
    return moment
      .utc(new Date())
      .add(-1, 'days')
      .format();
  }

  const previousIndex = currentIndex - 1;

  if (trips[previousIndex] && !trips[previousIndex].date.value) {
    return getMinDate(trips, previousIndex);
  }

  return lastTripDate(trips, currentIndex);
};

export default getMinDate;
